<!--suppress ALL -->
<!--suppress UnreachableCodeJS -->
<template>

	<form @submit.prevent="onSubmit">
		<smart-input :error="inputErrors.name" label='שם המרכז' v-model="form.name"></smart-input>
		<organizations-select v-if="isAdmin" v-model="form.organization_id"></organizations-select>
    <media-gallery-preview v-model="form.media_id" :image-url="company.logo"/>
		<smart-input
			:error="inputErrors.game"
			v-if="isAdmin" style="direction: ltr"
			:rows="5"
			:textarea="true" label="מידע משחק"
			v-model="form.game" name="game"/>
		<div class="form-group">
			<v-btn type="submit" color="success">שמירה</v-btn>
		</div>
	</form>
</template>


<script>
	import CompanyModule from "src/store/modules/Company.module";
	import FormView from "src/mixins/FormView";
	import OrganizationsSelect from "dev/view/organizations/OrganizationsSelect";
  import MediaGallery from "../../packages/gallery/MediaGallery";
  import MediaGalleryPreview from "../../packages/gallery/MediaGalleryPreview";

	export default {
		props: [],
		name: "company-form",
		components: {MediaGalleryPreview, MediaGallery, OrganizationsSelect},
		data() {
			return {
				form: {
					name: null,
					organization_id: null
				},
			};
		},
		mixins: [new FormView(CompanyModule, "company")],
		computed: {
			isNew() {
				return !!this.company.id;
			},
			isAdmin() {
				return this.$store.getters.isAdmin;
			},
		}
	};
</script>

<style>

</style>
